.chartDimensions {
  width: 100%;
  height: 100%;
}
